import React from 'react';
//import classes from './Spinner.module.css'; className={classes.Loader}
import classes from '../styles/Share.module.css';

const spinner = () => (
    <div className={classes.WholeBox} >
        <div className={classes.SpinnerBox}>
            <div  id={classes.Loading} ></div>
            <p>Nalaganje ...</p>
        </div>
    </div>
);

export default spinner;